module.exports = __webpack_public_path__ + "static/img/logo.fd6b3989.png";